import React from "react";

const ComponentMemoizer = ({ element, dependecies }) => {
  const MemoizedComponent = React.useMemo(
    () => <>{element}</>,
    [...dependecies]
  );
  return <React.Fragment>{MemoizedComponent}</React.Fragment>;
};

export default ComponentMemoizer;
